import React, { useState, useRef, useEffect, useContext, Suspense } from 'react';
import { useDispatch, ReactReduxContext } from 'react-redux';
//import SocialMediaComponent from './heading/SocialMediaComponent';
import { uploadProfileImage } from '../services/actions/actions';
import { Redirect } from 'react-router';
import { FINAL_RESUME, HEADING_LINK, EDUCATION_LINK, NEXT_EDUCATION_LABEL, NEXT_LABEL, NEXT_WORKHISTORY_LABEL, SUMMARY_LINK, WORKHISTORY_LINK, STATE_LIST, POPUP_TYPES, IMAGE_FOLDER_URL, QUICK_EDITOR, WORKHISTORY_TIPS_LINK } from '../constants/constants';
import ErrorValidator from '../ErrorValidator';
import QuickTips from './common/QuickTips';
// import {SAVE_RESUME} from '../constants/constants'
import Portfolio from './heading/Portfolio';
import { useResume } from '../context/ResumeContext';
import { usePopup } from '../context/PopupContext';
import { setBodyHeight } from '../helper';
import WpAPI from '../WpApi';
import ErrorIcon from './common/ErrorIcon';
const EditorHeading = (props) => {
  const { store } = useContext(ReactReduxContext);
  // const {resume} = useContext(ResumeContext);
  const ddRef = useRef();
  const {
    resume: {
      heading,
      // socials,
      portfolio,
      enabled_tabs,
    },
    handlers: {
      onValueChange,
      updateResumePreview,
      nuteralizeNextClick,
      resumeReview
    },
    next_clicked,
    next_label,
    toggleProfilePicture,
    hasReviewSuggestions,
    getFieldSuggestionId,
    showSuggestionPopup
  } = useResume();

  const confirmbox = usePopup();

  const dispatch = useDispatch();
  
  const validatorSet = {
    fname: { 
      other1: {
        msg: "Please Enter Your First Name",
        validator: val => false
      } 
    },
    lname: { 
      other1: {
        msg: "Please Enter Your Last Name",
        validator: val => false
      }
    },
    profession: { 
      other1: {
        msg: "Please Enter a Job Title",
        validator: val => false
      }
    },
    address: {
      other1: {
        msg: "Please Enter Your Address",
        validator: val => false
      }

    },
    city: {
      other1: {
        msg: "Please Enter Your City",
        validator: val => false
      }
    },
    state: {
      other1: {
        msg: "Please Enter Your State",
        validator: val => false
      }
    },
    country: {
      other1: {
        msg: "Please Enter Your Country",
        validator: val => false
      }
    },
    zipcode: {
      other1: {
        msg: "Please Enter Valid Zip",
        validator: val => {
          const zipreg = /^[a-z0-9][a-z0-9\- ]{0,14}[a-z0-9]$/i
          return (val.length ? !zipreg.test(val) : false);
        }
      }
    },
    phone: {
      other1: {
        msg: "Please Enter Your Phone Number",
        validator: val => false
      }
    },
    email: {
      empty: "Please Enter Your Email Address",
      other1: {
        msg: "Please Enter a Valid Email Address",
        validator: val => !(/\S+@\S+\.\S+/.test(val))
      }
    }
  };
  
  const validatorsSet2 = {
    // label: { empty: "Please Enter Label For Link" },
    link: {
      other: {
        msg: "Invalid URL",
        validator: val => {
          // return !(/^(https?:\/\/)/.test(val) || /^(www\.)/.test(val))
          return false;
        },
      }
    }

  }

  //For error validations
  const portfolioValidators = {}
  //For error validations
  const vObj = new ErrorValidator(validatorSet)
  //Style error
  const errorStyle = { color: "red", fontSize: "10px" };
  //Show error using this state
  const [error, setError] = useState({});
  //Flag is Do next redirect
  const [redirectNext, setredirectNext] = useState(false);

  const [openList, setOpenList] = useState(false);
  //Component asked to redirect, first validate
  const [redirectCall, setredirectCall] = useState(false);
  const [uploaded, setuploaded] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState('');
  const [blabel, setblabel] = useState('Upload Photo');
  const [imageName, setImageName] = useState(heading.hasOwnProperty('profile_picture') ? heading.profile_picture : '');

  const [checkField, setCheckField] = useState('');
  const [showToolTip, setShowToolTip] = useState(false);
  const [showNameInput, setShowNameInput] = useState(false);
  const [editName, setEditName] = useState(false);

  const toggleDropDown = () => {
    setOpenList(!openList);
  }

  const update = (input) => {
    const new_personal_detail = { ...heading, ...input, completed: false };
    updateResumePreview({ heading: new_personal_detail, current_tab: 'heading' });
  };
  //Quick edit mode
  const QEM = enabled_tabs.includes('completed')
  const label = (l) => QEM ? NEXT_LABEL : l
  const rURL = (u) => QEM ? FINAL_RESUME : u
  const nextClicked = () => {
    // debugger
    if (next_clicked && validateForm()) {
      //Set for next page
      nuteralizeNextClick({ next_label: label(NEXT_WORKHISTORY_LABEL) }, true, QEM ? '' : 'work_history')
      WpAPI.saveResmeProgress({
        email: heading.email,
        name: `${heading.fname} ${heading.lname}`,
        phone: heading.phone
        
      });
      return true;
    } else {
      //Set for own page
      if (next_clicked || next_label != label(NEXT_WORKHISTORY_LABEL)) {
        //Always run for next click and self label not matched
        nuteralizeNextClick({
          next_label: label(NEXT_WORKHISTORY_LABEL),
        });
      }
      return false;
    }
  };

  const errorExists = () => {
    let anyerror = [];
    Object.keys(error).map((key) => {
      if (error[key] != "") anyerror.push(key);
    });
    return anyerror.length > 0 ? true : false;
  };

  const validateForm = () => {
    if (redirectCall) {
      let h = vObj.validateFields(heading), pv = validatePortfolioForm()
      // let v = pv === true ? {...h} : { ...h, ...pv }
      let v = { ...h, ...pv }
      if (Object.keys(v).length == 0) {
        return true;
      } else {
        setError({ ...v });
        return false;
      }
    } else {
      return false;
    }
  }
  const validatePortfolioForm = () => {
    let v = {}
    //validate for each softwares, store validate in object
    portfolio && Object.keys(portfolio.set).map(key => {
      if (!portfolioValidators.hasOwnProperty(key)) portfolioValidators[key] = new ErrorValidator(validatorsSet2)
      const er = portfolioValidators[key].validateFields(portfolio.set[key])
      if (Object.keys(er).length) v[key] = er
    })
    return v
    // if (Object.keys(v).length == 0) {
    //   return true;
    // } else return v;
  }

  const removeError = (e) => {
    setError({ ...error, [e.target.name]: "" });
  }

  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
    update({ validated: { ...heading.validated, [e.target.name]: false } })
  }

  const fieldBlur = e => {
    setCheckField('');
    // const er = validateFields(e.target.name)
    const er = vObj.validateFields(e.target.value, e.target.name)
    if (!Object.keys(er).length) {
      update({ validated: { ...heading.validated, [e.target.name]: true } })
    } else setError({ ...error, ...er });
    props?.review && setTimeout(() => resumeReview(), 1000);
  }


  useEffect(() => {
    if (nextClicked()) setredirectNext(true);
    else setredirectNext(false);
    setredirectCall(false);

  }, [redirectCall]);
  useEffect(() => {
    //browser issue, page does not get opened to the top
    window.scrollTo(0, 0);
    confirmbox.configurePopup(POPUP_TYPES);
    const body = document.querySelector('body');
    if (body) {
        body.style.height = '100%';
    }
  }, []);

  const _hasReviewSuggestions = (field) => {
    return  props?.review && hasReviewSuggestions('personal_details', field)
  }

  if (next_clicked && !redirectCall) setredirectCall(true);
  if (redirectNext) {
    history.pushState(null, HEADING_LINK);
    return <Redirect to={rURL(WORKHISTORY_LINK)} />
  }

  
  //Dont allow render allinone editor in case resume is not completed
  // if(!props.hasOwnProperty('tabOpened') && heading.fname.length && enabled_tabs.indexOf('completed') > -1) return <Redirect to={QUICK_EDITOR} />

  const processing = (s) => s ? setblabel('Processing...') : setblabel('Upload Photo')

  const updateImage = (f) => {
    processing(true);
    if (f[0] !== undefined) {
      const uploadedImage = f[0];
      if (uploadedImage.size > 2097152) {
        setErrorMsg('The image exceeds the maximum allowed size (2MB). Please try a smaller image.');
        // setTimeout(() => {
        //   setErrorMsg('');
        // }, 5000);
        processing(false);
        return false;
      } else {
        (dispatch(uploadProfileImage(f[0])).then(res => {
          if (res.msg == 'success') {
            processing(false);
            setImageName(res.name);
          }
        }).catch(error => {
          console.log('got en error', error);
          // Convert error object to string for React rendering
          const errorMessage = error instanceof Error ? error.message : String(error);
          setErrorMsg(errorMessage);
          setTimeout(() => {
            setErrorMsg('');
          }, 5000);
          processing(false);
        }))
      }
    }
  }
  const showTabOpenCloseIcon = () => (
    props.hasOwnProperty('tabOpened') ?
      <span className="open-close-btn blue" onClick={() => {
        props.tabClicked('heading', false);
        setShowNameInput(false);
        setBodyHeight();
      }}>
        {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
        </span> : ''
  )
  const getShortName = (fname, lname) => {
    const a = fname ? fname.charAt(0) : "";
    const b = lname ? lname.charAt(0) : "";
    return a + b;
  };

  const _getFieldSuggestionId = (field) => {
    return  props?.review && getFieldSuggestionId('personal_details',field);
  }
  const clickHandler = (element_id) => {
    showSuggestionPopup(element_id);
  };
  return (
    <div className="editor-block-inner">
      {props.splash}
      <div className="editor-area blue-line">
        <div className="form-heading">
          {/* <div className="on-off-btn disabled">
            <span><i></i></span>
          </div> */}
          {props.hasOwnProperty('tabClicked') 
          ? <><div className="heading" onClick={() => {
            if(!showNameInput){
              props.tabClicked('heading', editName);
              setEditName(false);
            }
          }}>
            {showNameInput 
            ? '' 
            : <>
                <h1>
                {heading.name ?? `Contact Information`} {
                    props?.tabOpened && props.tabOpened 
                    ? <i className="icon-pencil" onMouseOver={() => setEditName(true)} onClick={() => {
                      setShowNameInput(true);
                      props.tabClicked('heading', editName);
                    }}></i>
                    : ''
                  }
                </h1>
              </>
            }
            {showNameInput 
            ? <input
              type="text"
                className="edit-block-name"
              name="name"
              value={heading.name ?? `Personal Information`}
              onChange={(e) => {
                props.tabClicked('heading', true)
                update({ name: e.target.value });
              }}
              onFocus={(e) => fieldFocus(e)}
              onBlur={(e) => {
                fieldBlur(e);
                setShowNameInput(false)
              }
              //onMouseOut={(e) => setShowNameInput(false)
            }
            />
            : '' }
            {error.name && (
              <span style={errorStyle}>{error.name}</span>
            )}
            <p className='heading-para'>Fill out your basic personal and contact information.</p>
          </div></> 
          : <div className="heading" style={{cursor: "default"}}>
              <h1>{heading.name ?? `Personal Information`}</h1>
              <p className='heading-para'>Fill out your basic personal and contact information.</p>
            </div>
          }
          {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips">
            <span
              onClick={() => {
                setShowToolTip(!showToolTip);
              }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
            {showToolTip ? <QuickTips section='heading' setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
          </div>}
          {showTabOpenCloseIcon()}
        </div>
        {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="editor-form-wrap">
          <div className="editor-form">
          <div className="form-row column-2">
            <div className="field-wrap" id={_getFieldSuggestionId('fname')}>
              {/* <label htmlFor="fname"  className={`label${checkField == 'fname' ? ' label-focus': '' }`}>First Name { _hasReviewSuggestions('fname') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('fname'))} />}</label>  */}
              <input
                placeholder="First Name"
                type="text"
                className={`validate ${ _hasReviewSuggestions('fname') && 'review-error'}`}
                name="fname"
                value={heading.fname}
                onChange={(e) => {
                  update({ fname: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.fname && <span style={errorStyle}>{error.fname}</span>}
            </div>
            <div className="field-wrap" id={_getFieldSuggestionId('lname')}>
              {/* <label htmlFor="lname" className={`label${checkField == 'lname' ? ' label-focus': '' }`}>Last Name { _hasReviewSuggestions('lname') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('lname'))} />}</label> */}
              <input
                placeholder="Last Name"
                type="text"
                className={`validate ${ _hasReviewSuggestions('lname') && 'review-error'}`}
                name="lname"
                value={heading.lname}
                onChange={(e) => {
                  update({ lname: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.lname && <span style={errorStyle}>{error.lname}</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap" id={_getFieldSuggestionId('profession')}>
              {/* <label htmlFor="profession" className={`label${checkField == 'profession' ? ' label-focus': '' }`}>Job Title { _hasReviewSuggestions('profession') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('profession'))} />}</label> */}
              <input
                placeholder="Job Title"
                type="text"
                className={`form-input validate ${ _hasReviewSuggestions('profession') && 'review-error'}`}
                name="profession"
                value={heading.profession}
                onChange={(e) => {
                  update({ profession: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.profession && (
                <span style={errorStyle}>{error.profession}</span>
              )}
            </div>
          </div>
          <div className="form-row column-2">
            <div className="field-wrap"  id={_getFieldSuggestionId('address')}>
              {/* <label htmlFor="address" className={`label${checkField == 'address' ? ' label-focus': '' }`}>Address 1  { _hasReviewSuggestions('address') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('address'))} />}</label> */}
              <input
                placeholder="Address 1"
                type="text"
                className={`validate ${ _hasReviewSuggestions('address') && 'review-error'}`}
                name="address"
                value={heading.address}
                onChange={(e) => {
                  update({ address: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />

              {error.address && (
                <span style={errorStyle}>{error.address}</span>
              )}
            </div>
            <div className="field-wrap"  id={_getFieldSuggestionId('city')}>
              {/* <label htmlFor="city" className={`label${checkField == 'city' ? ' label-focus': '' }`}>Address 2  { _hasReviewSuggestions('city') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('city'))} />}</label> */}
              <input
                placeholder="Address 2"
                type="text"
                className={`validate ${ _hasReviewSuggestions('city') && 'review-error'}`}
                value={heading.city}
                name="city"
                onChange={(e) => {
                  update({ city: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.city && <span style={errorStyle}>{error.city}</span>}
            </div>
              {/*<div className="field-wrap">
                <label htmlFor="zipcode" className={`label${checkField == 'zipcode' ? ' label-focus': '' }`}>Zip Code</label>
                <input
                  type="text"
                  className={`validate ${ _hasReviewSuggestions('zipcode') && 'review-error'}`}
                  name="zipcode"
                  value={heading.zipcode}
                  onChange={(e) => {
                    update({ zipcode: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.zipcode && <span style={errorStyle}>{error.zipcode}</span>}
                </div>*/}
            </div>
            {/*<div className="form-row column-2">
              <div className="field-wrap">
                <label className={`label${checkField == 'state' ? ' label-focus': '' }`}>State</label>
                <div className="input-dd">
                  <input
                    className={`current-value validate ${ _hasReviewSuggestions('state') && 'review-error'}`}
                    type="text"
                    name="state"
                    onChange={e => update({ state: e.target.value })}
                    value={heading.state}
                    onFocus={(e) => fieldFocus(e)}
                    onBlur={(e) => fieldBlur(e)}
                  />
                  {error.state && <span style={errorStyle}>{error.state}</span>}
                </div>
              </div>
              <div className="field-wrap" id={_getFieldSuggestionId('country')}>
                <label htmlFor="country" className={`label${checkField == 'country' ? ' label-focus': '' }`}>Country { _hasReviewSuggestions('country') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('country'))} />}</label>
                <input
                  type="text"
                  className={`validate ${ _hasReviewSuggestions('country') && 'review-error'}`}
                  name="country"
                  value={heading?.country ?? ''}
                  onChange={(e) => {
                    update({ country: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                //{error.zipcode && <span style={errorStyle}>{error.zipcode}</span>}
              </div>
                </div>*/}
            <div className="form-row column-2">
              <div className="field-wrap" id={_getFieldSuggestionId('phone')}>
                {/* <label htmlFor="phone" className={`label${checkField == 'phone' ? ' label-focus': '' }`}>Phone { _hasReviewSuggestions('phone') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('phone'))} />}</label> */}
                <input
                  placeholder="Phone"
                  type="text"
                  className={`validate ${ _hasReviewSuggestions('phone') && 'review-error'}`}
                  name="phone"
                  value={heading.phone}
                  onChange={(e) => {
                    update({ phone: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.phone && <span style={errorStyle}>{error.phone}</span>}
              </div>
              <div className="field-wrap"  id={_getFieldSuggestionId('email')}>
                {/* <label className={`label${checkField == 'email' ? ' label-focus': '' }`}>Email Address { _hasReviewSuggestions('email') && <ErrorIcon onClick={() => clickHandler(_getFieldSuggestionId('email'))} />}</label> */}
                <input
                  placeholder="Email Address"
                  type="text"
                  className={`validate ${ _hasReviewSuggestions('email') && 'review-error'}`}
                  name="email"
                  value={heading.email}
                  onChange={(e) => {
                    update({ email: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.email && <span style={errorStyle}>{error.email}</span>}
                <p className='email-disclaimer'>By creating a resume, you agree to receive emails — unsubscribe anytime.</p>
              </div>
            </div>
          </div>
        <Portfolio
          // portfolio={portfolio}
          // sociallinks={socials}
          // savePortfolio={savePortfolio}
          validatatorObj={portfolioValidators}
          error={error}
          setError={setError}
          validatorsSet2={validatorsSet2}
        />
        </div>}
      </div>
    </div>
  );
}

export default EditorHeading;